import React from 'react';
import { Button, useDisclosure } from '@chakra-ui/react';
import { MagnifyingGlass } from '@phosphor-icons/react';

import SearchModal from '../modals/SearchModal';

const UserSearch = ({ state, dispatch, refetch }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <Button leftIcon={<MagnifyingGlass />} variant="ghost" size="sm" mb="2" mr="2" onClick={onOpen}>
        User suchen
      </Button>
      <SearchModal isOpen={isOpen} onClose={onClose} refetch={refetch} dispatch={dispatch} state={state} />
    </>
  );
};

export default UserSearch;
